var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge"},[_c('vs-chip',{staticClass:"p-0 pr-2 pl-2",attrs:{"color":_vm.result ? 'success' : 'danger'}},[(_vm.result)?_c('span',[_vm._v("Success")]):_c('span',[_vm._v("Failed")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }